<div [formGroup]="form">
    <select class="form-control cursor_pointer input-font custom-select py-1" [id]="field.name"
        [formControlName]="field.name" (change)="dropdownevent()">
        <option value="">{{field.placeholder}}</option>
        @for(opt of field.options;track opt){
        <option [value]="opt.id">{{opt.name}}</option>
        }
    </select>
    @if(form.get(field.name)?.invalid && form.get(field.name)?.touched){
        <small class="invalid-feedback">{{field.label}} is required</small> 
}
</div>